<full-calendar #calendar [options]="options"></full-calendar>
